import throttle from '../utilities/throttle';

export default function FixedHeader() {
  return {
    init: () => {
      const header = document.querySelector('header');

      // when scrolled past 0
      window.addEventListener(
        'scroll',
        () => {
          if (window.scrollY > 0) {
            document.documentElement.classList.add('w-is-scrolled');
          } else {
            document.documentElement.classList.remove('w-is-scrolled');
          }
        },
        { passive: true }
      );

      // apply color scheme based on [w-b-color-scheme]
      const update = (e) => {
        const currentElements = document.elementsFromPoint(0, 0);
        const colorElements = currentElements.filter((element) =>
          element.matches('.w-b[data-w-color-scheme]:not(.w-b-wrapper-start)')
        );
        let color = 'default';
        if (colorElements && colorElements[0]) {
          color = colorElements[0].getAttribute('data-w-color-scheme');
        }
        header.setAttribute('data-w-color-scheme', color);
      };
      document.addEventListener('DOMContentLoaded', () => {
        update();
      });
      window.addEventListener('scroll', throttle(update, 100));
      document.addEventListener('carDetailApp.loaded', () => {
        update();
      });
      document.addEventListener('carListApp.loaded', () => {
        update();
      });
    },
  };
}
